var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mb-0",attrs:{"color":"warning","rounded":"0","outlined":"","text":""}},[_c('span',{staticClass:"text-body-2 text--primary"},[_vm._v(" Please complete your information below ")])])}
var staticRenderFns = []

export { render, staticRenderFns }